import React, { useState } from "react";

// Helper to format the date

// Helper to group tasks by 'dayOfWeek' and 'created_at' date
const groupTasksByDay = (tasks) => {
  // Safety check: ensure tasks is an array
  if (!Array.isArray(tasks) || tasks.length === 0) {
    return {};
  }

  const formatDate = (isoString) => {
    if (!isoString) return "";
    try {
      const date = new Date(isoString);
      return new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(date);
    } catch (e) {
      const parts = isoString.split(" ")[0].split("-");
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
  };

  const grouped = {};

  tasks.forEach((task) => {
    if (!task) return; // Skip null/undefined tasks

    // Extract the date part (YYYY-MM-DD) for grouping, ensuring consistency
    const date = task.due_date ? task.due_date.substring(0, 10) : "No Date";

    // Create a unique key for the day: Date + DayOfWeek
    const dayKey = `${formatDate(task.due_date)} ${task.dayOfWeek || ""}`;

    if (!grouped[dayKey]) {
      grouped[dayKey] = [];
    }
    grouped[dayKey].push(task);
  });
  return grouped;
};

// Component to render the status icon
const TaskStatusIcon = ({ isCompleted }) => {
  const style = {
    fontSize: "14px",
    marginRight: "8px",
    fontWeight: "bold",
  };

  // Use a green checkmark or a red cross based on isCompleted
  if (isCompleted) {
    return <span style={{ ...style, color: "#38A169" }}>&#10003;</span>; // Green checkmark
  }
  return <span style={{ ...style, color: "#E53E3E" }}>&#10005;</span>; // Red 'x' cross
};

export const TaskCard = ({ tasks = {} }) => {
  // State to toggle between 'MIT List' and 'Do List'. Default to MIT List as shown in image.
  const [activeList, setActiveList] = useState("MIT List");

  // Select the list based on the active state, with fallback to empty array
  const currentTasks =
    activeList === "MIT List" ? tasks.mitTasks || [] : tasks.doListTasks || [];





  // Group the current list for display
  const groupedTasks = groupTasksByDay(currentTasks || []);
  const dayKeys = Object.keys(groupedTasks);

  // --- Toggle Buttons ---
  const ToggleButtons = () => (
    <div className="d-flex flex-row gap-2 mb-4">
      {/* MIT List Button */}
      <button
        onClick={() => setActiveList("MIT List")}
        className={`btn btn-sm rounded-pill px-3 ${
          activeList === "MIT List" ? "btn-primary" : "btn-outline-primary"
        }`}
        style={{
          backgroundColor:
            activeList === "MIT List" ? "#008CFF" : "transparent",
          color: activeList === "MIT List" ? "#fff" : "#008CFF",
          borderColor: "#008CFF",
          fontSize: "14px",
          height: "28px",
          lineHeight: "1",
        }}
      >
        MIT List
      </button>

      {/* Do List Button */}
      <button
        onClick={() => setActiveList("Do List")}
        className={`btn btn-sm rounded-pill px-3 ${
          activeList === "Do List" ? "btn-primary" : "btn-outline-primary"
        }`}
        style={{
          backgroundColor: activeList === "Do List" ? "#008CFF" : "transparent",
          color: activeList === "Do List" ? "#fff" : "#008CFF",
          borderColor: "#008CFF",
          fontSize: "14px",
          height: "28px",
          lineHeight: "1",
        }}
      >
        Do List
      </button>
    </div>
  );

  // --- Task Item Renderer ---
  const renderTaskItem = (task, index) => {
    // Extract the task title, removing <p> tags if present
    const rawTitle = task.title.replace(/<\/?p>/g, "");

    return (
      <div key={index} className="d-flex align-items-center mb-1">
        <TaskStatusIcon isCompleted={task.isCompleted} />

        {/* Task Label */}
        <span style={{ color: "#C8CED3", fontSize: "16px", marginLeft: "8px" }}>
          {task.level}: {rawTitle}
        </span>
      </div>
    );
  };

  // --- Main Render ---
  return (
    <div className="d-flex flex-column w-100">
      {/* Radio Buttons / Toggles */}
      <ToggleButtons />

      {/* Grouped Tasks Display */}
      {dayKeys.length === 0 ? (
        <span style={{ color: "#8798A7", fontStyle: "italic" }}>
          No tasks found for the {activeList}.
        </span>
      ) : (
        dayKeys.map((dayKey, index) => (
          <div key={index} className="task-day-container">
            {/* Day Header (e.g., 2024/12/17 Tuesday) */}
            <h4
              className="fw-normal mb-2"
              style={{ color: "#8798A7", fontSize: "18px" }}
            >
              {dayKey}
            </h4>

            {/* List of Tasks for that Day */}
            <div className="d-flex flex-column">
              {groupedTasks[dayKey].map((task, taskIndex) =>
                renderTaskItem(task, taskIndex),
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};
